import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    FETCH_FORMATION_SKILLS_REQUEST,
    fetchFormationSkillsSuccess,
    fetchByFormationSkillsFail, // Wait, I named it fetchFormationSkillsFail in actions
    UPDATE_FORMATION_SKILLS_BULK_REQUEST,
    updateFormationSkillsBulkSuccess,
    updateFormationSkillsBulkFail,
    setFormationSkillLoading,
    fetchFormationSkillsFail,
    FETCH_ALL_FORMATION_SKILLS_REQUEST,
    fetchAllFormationSkillsSuccess,
    fetchAllFormationSkillsFail,
} from "../actions/formationSkillActions";

import { fetchFormationsRequest } from "../actions/formationsActions";

import { API_BASE_URL, getRequest, postRequest } from "../../../api";

const getUid   = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function* fetchByFormationSaga(action) {
    const { formationId } = action.payload;
    const url   = `${API_BASE_URL}/api/formation-skills/formation/${formationId}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setFormationSkillLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchFormationSkillsSuccess(resp.data));
    } catch (e) {
        yield put(fetchFormationSkillsFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setFormationSkillLoading(false));
    }
}

export function* fetchAllFormationSkillsSaga() {
    const url   = `${API_BASE_URL}/api/formation-skills/company`;
    const uid   = getUid();
    const token = getToken();

    yield put(setFormationSkillLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchAllFormationSkillsSuccess(resp.data));
    } catch (e) {
        yield put(fetchAllFormationSkillsFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setFormationSkillLoading(false));
    }
}

export function* updateFormationSkillsBulkSaga(action) {
    const { formationId, skills } = action.payload;
    const url   = `${API_BASE_URL}/api/formation-skills/bulk/${formationId}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setFormationSkillLoading(true));
    try {
        yield call(postRequest, { url, data: skills, uid, token });
        yield put(updateFormationSkillsBulkSuccess());
        // Refresh formations to update the catalogue view
        yield put(fetchFormationsRequest());
        yield call([Swal, Swal.fire], { icon: "success", text: "Liaisons mises à jour", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(updateFormationSkillsBulkFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: e.response?.data?.message || "Erreur lors de la mise à jour", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setFormationSkillLoading(false));
    }
}

export default function* formationSkillSaga() {
    yield takeLatest(FETCH_FORMATION_SKILLS_REQUEST, fetchByFormationSaga);
    yield takeLatest(FETCH_ALL_FORMATION_SKILLS_REQUEST, fetchAllFormationSkillsSaga);
    yield takeLatest(UPDATE_FORMATION_SKILLS_BULK_REQUEST, updateFormationSkillsBulkSaga);
}
